import { Pipe, PipeTransform } from '@angular/core';
import { AllClients } from '../Interfaces/SQL-morning-responses';

@Pipe({
	name: 'openObligo',
})
export class OpenObligoPipe implements PipeTransform {
	transform(client: AllClients): number {
		return (client.CMC || 0) - (+(client.COD || 0) + +(client.COC || 0)) - +(client.AddObligo || 0);
	}
}
